if (!customElements.get('product-personalization')) {
  class ProductPersonalization extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.product-personalization__input');
      if (!this.input) return;

      this.propertyName = this.input.getAttribute('name');
      this.input.addEventListener('input', this.handleInput.bind(this));
      this.syncProperty();
    }

    handleInput() {
      if (this.input.dataset.lettersOnly !== undefined) {
        const cleaned = this.input.value.replace(/[^\p{L}]/gu, '');
        if (cleaned !== this.input.value) {
          const caret = Math.max(
            0,
            this.input.selectionStart - (this.input.value.length - cleaned.length)
          );
          this.input.value = cleaned;
          this.input.setSelectionRange(caret, caret);
        }
      }

      this.syncProperty();
    }

    /**
     * Keeps the line item property out of the form data while the field is
     * empty, so items added without personalization stay unchanged.
     */
    syncProperty() {
      if (this.input.value.trim().length === 0) {
        this.input.removeAttribute('name');
      } else {
        this.input.setAttribute('name', this.propertyName);
      }
    }
  }

  customElements.define('product-personalization', ProductPersonalization);
}